<!-- Seven columns to match the seven flex:1 grid columns above; horizontal padding here would break that alignment. -->
<div class="py-md grid grid-cols-7 text-center">
  <!-- The billing unit column carries no breakdown. -->
  <div></div>

  @for (counts of slots(); track $index) {
    <div class="px-md">
      @if (counts) {
        <!-- leading-none on the labels: text-xs otherwise pads a 12px glyph into a 16px line box, which reads as a gap. -->
        <p class="text-text-tertiary-600 text-xs leading-none">{{ 'product-view.property-overview.roomGroups' | translate }}</p>
        <p class="text-text-primary-900 mt-xxs text-sm font-medium">{{ counts.roomGroupsImpacted }}/{{ counts.roomGroups }}</p>

        <p class="text-text-tertiary-600 mt-lg text-xs leading-none">{{ 'product-view.property-overview.devices' | translate }}</p>
        <!-- One grid rather than three stacks: the icons are taller than the "Total" label, so only a shared row keeps the counts on one line. -->
        <div class="mt-xs gap-x-lg gap-y-xs mx-auto grid w-fit grid-cols-3 items-center">
          <svg-icon key="x-circle" class="text-fg-error-primary justify-self-center" fontSize="16px"></svg-icon>
          <svg-icon key="hourglass-01" class="text-utility-indigo-600 justify-self-center" fontSize="16px"></svg-icon>
          <p class="text-text-tertiary-600 text-xs leading-none">{{ 'system.total' | translate }}</p>

          <p class="text-text-primary-900 text-sm font-medium">{{ counts.devicesInError }}</p>
          <p class="text-text-primary-900 text-sm font-medium">{{ counts.devicesInPending }}</p>
          <p class="text-text-primary-900 text-sm font-medium">{{ counts.devices }}</p>
        </div>
      }
    </div>
  }
</div>
